<template>
    <!-- Componente para mostrar la cotización de cetelem -->
    <div class="cetelem-quotation bg-light-gray2 py-8 px-4 h-full shadow">
        <h3 class="font-medium text-xl lg:text-2xl text-center px-4 leading-tight lg:leading-normal sm:mt-2">Simulación
            CETELEM</h3>
        <div
            class="flex flex-col space-y-6 md:flex-row md:space-y-0 md:space-x-4 lg:flex-col lg:space-x-0 lg:space-y-6 xl:flex-row xl:space-y-0 xl:space-x-4 mt-8 md:mt-12 mb-8">
            <div class="text-center w-full md:w-1/3 lg:w-full xl:w-1/3 bg-brown py-4">
                <p class="font-medium">Plazo</p>
                <p class="text-xl mt-2 xl:mt-4">{{ instalments[instSelected] }} MESES</p>
                <p class="mt-2 xl:mt-4 text-sm">Tasa de Interés <span class="text-xs align-top">2</span><br> {{ tasa }}%
                </p>
            </div>
            <div class="text-center w-full md:w-1/3 lg:w-full xl:w-1/3  bg-brown py-4">
                <p class="font-medium">Pago Mensual <span class="text-xs align-top">1</span></p>
                <p class="text-xl mt-2 xl:mt-4">${{ formatPrice(pagoMensual) }}</p>
                <p class="mt-2 xl:mt-4 text-sm">CAT promedio sin IVA <span class="text-xs align-top">3</span><br>
                    {{ cat }}%</p>
            </div>
            <div class="text-center w-full md:w-1/3 lg:w-full xl:w-1/3 bg-brown py-4">
                <p class="font-medium">Financiamiento</p>
                <p class="text-xl mt-2 xl:mt-4">${{ formatPrice(financiamiento) }}</p>
                <div class="mt-2 xl:mt-4 text-sm leading-tight">
                    <p>Total a Pagar</p>
                    <p>${{ formatPrice(totalAPagar) }}</p>
                </div>
            </div>
        </div>
        <div class="text-center mt-6 bg-brown py-4">
            <p class="font-medium">Elige tu Aseguradora<span class="text-xs align-top">1</span></p>
            <div class="flex flex-wrap md:flex-no-wrap justify-center space-x-3 mt-4">
                <div
                    class="mb-4 md:mb-0"
                    v-for="(insurance, index) in insurances"
                    :key="insurance.idAseguradora"
                >
                    <button
                        v-if="insurance.terms[instSelected]"
                        class="w-32 rounded-3xl py-2 text-center text-sm"
                        :class="[insuSelected === index ? ['bg-black', 'text-white'] : ['bg-white', 'text-black']]"
                        @click="insuSelected = index"
                    >
                        <!-- <img class="h-6 w-auto" :src="`${insurance.urlLogo}`" :alt="insurance.aseguradora"> -->
                        {{ insurance.idAseguradora === 'EIKOSABA' ? 'ABA' : insurance.aseguradora }}
                        <br>
                        {{ ` $${formatPrice(insurance.terms[instSelected].pagoMensual1)}` }}
                    </button>
                </div>
            </div>
        </div>
        <div class="flex flex-col items-center my-8">
            <div class="mt-6 md:mt-0 flex">
                <label class="checkbox-container">
                    <input
                        type="checkbox"
                        v-model="cetelemTerms"
                    >
                    <span class="checkmark"></span>
                </label>
                <p class="text-sm">Acepto los <a
                        class="underline"
                        target="_blank"
                        href="https://www.cetelem.com.mx/terminos-y-condiciones.html"
                    >Términos y condiciones</a> de la Política de privacidad</p>
            </div>
            <button
                class="w-56 xs:w-68 sm:w-88 hyundai-button sm:text-base mx-auto mt-4"
                @click="chargeCetelemForm()"
            >Descarga tu <span class="font-medium">Tabla de Pagos<br class="sm:hidden"> (Amortización)</span></button>
        </div>
        <div>
            <div class="mt-6 sm:mt-8 text-sm">
                <p>1. Pago mensual con IVA con seguro de vehículo incluido.</p>
                <p>2. Tasa de interés anual.</p>
                <p>3. CAT promedio sin IVA “informativo”.</p>
            </div>
            <p class="text-sm">*Los montos y las tasas pueden variar dependiendo de tu historial crediticio.</p>
            <div class="mt-6 text-sm">
                <p>La información que contiene el “Cotizador Cetelem” del sitio web, tiene como objetivo principal
                    proporcionar a los visitantes, en una forma general, información sobre los productos y servicios de
                    Cetelem, S.A. de C.V., SOFOM, E.R., (en lo sucesivo “Cetelem”), pero esto no implica ni garantiza
                    que la información presentada pueda satisfacer los requisitos de precisión, detalle o exactitud
                    requerida por sus visitantes ya que no constituyen una oferta por parte de Cetelem, por lo que la
                    cotización resultante puede variar al momento de la firma del contrato correspondiente.</p>
                <div v-show="showMoreDisc">
                    <p class="mt-2">Por otra parte, cualquier propuesta, oferta, sugerencia o en general cualquier tipo
                        de información que Cetelem reciba por medio de correo electrónico, teléfonos, y/o cualquier
                        otro medio de comunicación indicado en este sitio web, no implicará la aceptación, compromiso
                        u obligación hacia el remitente. Asimismo, dichos medios de comunicación no serán medios
                        aceptados por Cetelem para la recepción de cualquier tipo de notificación judicial o
                        extrajudicial, demandas, emplazamientos o requerimientos de autoridad.</p>
                    <p class="mt-2">Los modelos, versiones y precios que se muestran en el “Cotizador Cetelem” del sitio
                        web, pueden diferir de los modelos, versiones y precios ofrecidos por la red de distribuidores
                        autorizados Hyundai, por lo que Cetelem no se responsabiliza por la disponibilidad ni la calidad
                        del vehículo seleccionado. De igual modo, las promociones de financiamiento de Cetelem podrán
                        variar según la marca, modelo y versión, para mayor información consulta a los distribuidores
                        autorizados Hyundai.</p>
                </div>
                <p
                    class="underline cursor-pointer mt-2"
                    @click="showMoreDisc = showMoreDisc ? false : true"
                >{{ !showMoreDisc ? 'Ver más' : 'Ver menos' }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    props: [
        "instalments",
        "instSelected",
        "cetelemQuotation",
        "versionId",
        "subsidiary",
        "isIframe",
    ],
    data() {
        return {
            url: $(".url").text(),
            webpage: $(".webpage").text(),
            // Variable para almacenar la aseguradora seleccionada
            insuSelected: 0,
            // Variable para almacenar el plan seleccionado
            planSelected: 0,
            // Variable para determinar si mostrar la descripción
            // completa del disclaimer o no
            showMoreDisc: false,
            // Variable para determinar si se aceptaron los TyC
            cetelemTerms: false,
        };
    },
    watch: {
        // Observa la variable instSelected para determinar si
        // está disponible el plazo con la aseguradora seleccionada
        instSelected: function (val) {
            // if (this.cetelemQuotation.planes && !this.insurances) {
            //     this.$emit('bad-instalment')
            // }
            // this.insuSelected = 0
            if (this.insurances) {
                for (const ins in this.insurances) {
                    if (!this.insurances[ins].terms[this.instSelected]) {
                        this.insuSelected++;
                    }
                }
                if (this.insuSelected > 2) {
                    this.$emit("bad-instalment");
                }
            }
        },
    },
    methods: {
        // Función para dar formato a precios
        formatPrice(price) {
            return parseFloat(price)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        },
        // Función para cargar el formulario de cetelem
        // para descargar la tabla de amortización
        chargeCetelemForm() {
            if (this.cetelemTerms) {
                let quotData = {
                    pagoMensual: this.pagoMensual,
                    montoTotal: this.financiamiento,
                    totalAPagar: this.totalAPagar,
                    idAseguradora:
                        this.insurances[this.insuSelected].idAseguradora,
                    idPlan: this.cetelemQuotation.planes[this.planSelected]
                        .idPlan,
                };
                this.$emit("charge-cetelem-form", quotData);
            } else {
                Swal.fire({
                    icon: "error",
                    title: '<h3 class="text-2xl leading-tight font-medium">Datos requeridos</h3>',
                    html: "<p>Debes aceptar los Términos y Condiciones</p>",
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton:
                            "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2",
                    },
                    buttonsStyling: false,
                });
            }
        },
        // Función para obtener el pago mensual de la simulación
        getPagoMensual(idx) {
            return this.insurances[idx].terms[this.instSelected].pagoMensual1;
        },
    },
    computed: {
        // Retorna los datos de la cotización de acuerdo al plan seleccionado
        insurances() {
            if (this.cetelemQuotation.planes) {
                // let insurances = this.cetelemQuotation.planes[0].termsXAseguradora
                // if (insurances[this.insuSelected].terms[this.instSelected]) {
                //     return insurances
                // }
                return this.cetelemQuotation.planes[this.planSelected]
                    .termsXAseguradora;
            }
            return null;
        },
        // Variables computadas para la cotización
        tasa() {
            return this.insurances
                ? this.insurances[this.insuSelected].terms[this.instSelected]
                    .tasa
                : 0;
        },
        pagoMensual() {
            return this.insurances
                ? this.insurances[this.insuSelected].terms[this.instSelected]
                    .pagoMensual1
                : 0;
        },
        cat() {
            return this.insurances
                ? this.insurances[this.insuSelected].terms[this.instSelected]
                    .cat
                : 0;
        },
        financiamiento() {
            // return this.insurances ? this.insurances[this.insuSelected].terms[this.instSelected].montoTotal : 0
            return this.insurances ? this.cetelemQuotation.montoFinanciar : 0;
        },
        totalAPagar() {
            return this.insurances
                ? this.insurances[this.insuSelected].terms[this.instSelected]
                    .montoTotal
                : 0;
        },
    },
};
</script>

<style lang="scss">
.cetelem-quotation {

    /* Customize the label (the container) */
    .checkbox-container {
        display: block;
        position: relative;
        padding-left: 2rem;
        /* margin-bottom: 12px; */
        cursor: pointer;
        /* font-size: 22px; */
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .checkbox-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.2rem;
        width: 1.2rem;
        background-color: #fff;
        border: 1px solid #444444;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .checkbox-container input:checked~.checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .checkbox-container .checkmark:after {
        left: 4px;
        top: -3px;
        width: 10px;
        height: 18px;
        border: solid #000;
        border-width: 0 4px 4px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    /** Radio Button **/
    /* Customize the label (the container) */
    .radio-container {
        display: block;
        position: relative;
        padding-left: 2.5rem;
        /* margin-bottom: 12px; */
        cursor: pointer;
        /* font-size: 22px; */
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default radio button */
    .radio-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom radio button */
    .radio-checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.5rem;
        width: 1.5rem;
        background-color: #ededed;
        border-radius: 50%;
        border: 1px solid #000;
    }

    /* On mouse-over, add a grey background color */
    /* .radio-container:hover input ~ .radio-checkmark {
    background-color: #ccc;
    } */

    /* When the radio button is checked, add a blue background */
    /* .radio-container input:checked ~ .radio-checkmark {
    background-color: #ededed;
    } */

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .radio-checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .radio-container input:checked~.radio-checkmark:after {
        display: block;
    }

    /* Style the indicator (dot/circle) */
    .radio-container .radio-checkmark:after {
        top: 5px;
        left: 5px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #000;
    }
}
</style>